module.exports = __webpack_public_path__ + "img/9GB.12eac0ac.jpg";